import { App, message as staticMessage } from 'antd';
import type { MessageInstance } from 'antd/es/message/interface';
import React from 'react';

type ModalHookAPI = ReturnType<typeof App.useApp>['modal'];

let globalMessage: MessageInstance | null = null;
let globalModal: ModalHookAPI | null = null;

export const setAppBridgeInstance = (
  messageInstance: MessageInstance,
  modalInstance: ModalHookAPI,
) => {
  globalMessage = messageInstance;
  globalModal = modalInstance;
};

export const getAppBridgeMessage = (): MessageInstance => {
  return globalMessage || staticMessage;
};

export const getAppBridgeModal = (): ModalHookAPI | null => {
  return globalModal;
};

export const appMessage = {
  success: (content: string) =>
    globalMessage
      ? globalMessage.success(content)
      : staticMessage.success(content),
  error: (content: string) =>
    globalMessage ? globalMessage.error(content) : staticMessage.error(content),
  warning: (content: string) =>
    globalMessage
      ? globalMessage.warning(content)
      : staticMessage.warning(content),
  info: (content: string) =>
    globalMessage ? globalMessage.info(content) : staticMessage.info(content),
  loading: (content: string) =>
    globalMessage
      ? globalMessage.loading(content)
      : staticMessage.loading(content),
};

export const AppMessageBridgeHolder: React.FC = () => {
  const { message, modal } = App.useApp();

  React.useEffect(() => {
    setAppBridgeInstance(message, modal);
  }, [message, modal]);

  return null;
};
